import EnErrorCodes from '../en/common';

const CommonErrorCodes: Record<keyof typeof EnErrorCodes, string> = {
  COM00001: 'ocorreu um erro inesperado',
} as const;

export default CommonErrorCodes;
